/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { agentGetAgentConfig } from '../fn/agent-data-for-token/agent-get-agent-config';
import { AgentGetAgentConfig$Params } from '../fn/agent-data-for-token/agent-get-agent-config';
import { IxlabFrontendConfigDto } from '../models/ixlab-frontend-config-dto';

@Injectable({ providedIn: 'root' })
export class AgentDataForTokenApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `agentGetAgentConfig()` */
  static readonly AgentGetAgentConfigPath = '/api/agent/config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agentGetAgentConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  agentGetAgentConfig$Response(params?: AgentGetAgentConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<IxlabFrontendConfigDto>> {
    const obs = agentGetAgentConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agentGetAgentConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agentGetAgentConfig(params?: AgentGetAgentConfig$Params, context?: HttpContext): Observable<IxlabFrontendConfigDto> {
    const resp = this.agentGetAgentConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<IxlabFrontendConfigDto>): IxlabFrontendConfigDto => r.body)
    );
  }

}
